import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderableItemService, SizePrice } from 'ngx-web-api';

@Component({
  selector: 'fts-size-prices',
  templateUrl: './size-prices.component.html',
  styleUrls: ['./size-prices.component.scss'],
})
export class SizePricesComponent {
  @Input()
  itemName: string;
  @Input()
  selectedSizePrice: SizePrice;
  @Input()
  sizePrices: SizePrice[];
  @Output()
  selectedSizePriceChange: EventEmitter<SizePrice> = new EventEmitter();

  constructor(public orderableItemService: OrderableItemService) {}

  onSizePriceChanged(sizePrice: SizePrice) {
    this.selectedSizePriceChange.emit(sizePrice);
  }
}
